
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"800","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 5v14a3 3 0 003 3h10a3 3 0 003-3V9a3 3 0 00-3-3H5a1 1 0 01-1-1zm3.25 7a.75.75 0 01.75-.75h8a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75zm0 3.5a.75.75 0 01.75-.75h5.5a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75z","fill":"#1C274D"}}),_c('path',{attrs:{"d":"M4.409 4.087A1 1 0 015 5h12c.345 0 .68.044 1 .126v-.82a2 2 0 00-2.283-1.98L4.92 3.87a1.068 1.068 0 00-.511.218z","fill":"#1C274D"}})])
          )
        }
      }
    